import { OnboardingPageWithProvider as OnboardingPage } from './OnboardingPage';

export default OnboardingPage;
